import { MaterialListResponse, type MaterialMilestone } from "@edu/shared";
import { call, callVoid } from "../../lib/api.ts";

/**
 * Три ручки ученика для присланных ему ссылок и файлов
 * (`docs/material-receipt-design.md`, раздел 13, часть А).
 *
 * ⚠️ **Своим модулем, а не импортом из `features/students/`**: там ручки
 * преподавателя (выдача, отзыв, удаление), и экран ученика не тянет модули
 * преподавателя ни одним путём. Общее у двух модулей только `call`.
 *
 * Список это та же ручка, что у преподавателя, `GET /v1/materials?studentId=`:
 * ученик называет в ней себя, а сервер по этому признаку включает ученическую
 * ветку предиката (свои строки, без отозванного, только при открытом архиве,
 * ни одного чужого получателя, `repo/material-list.ts`). Второй ручки под
 * ученика не заводится: две ручки к одним строкам разошлись бы при первой
 * правке правила видимости.
 */

export function listMyMaterials(
  myUserId: string,
  cursor: string | null,
): Promise<MaterialListResponse> {
  const params = new URLSearchParams({ studentId: myUserId });
  if (cursor !== null) params.set("cursor", cursor);
  return call(`/v1/materials?${params.toString()}`, {}, MaterialListResponse);
}

/**
 * Отметка «открыт». Пишется сервером один раз, повтор ничего не двигает, поэтому
 * клиент не помнит, отмечал ли он уже: лишний запрос дешевле второго места, где
 * хранится то же самое.
 */
export function markOpened(materialId: string): Promise<void> {
  return callVoid(`/v1/materials/${materialId}/opened`, { method: "POST" });
}

/** Веха воспроизведения файла. Сервер хранит большее из присланного. */
export function sendProgress(materialId: string, milestone: MaterialMilestone): Promise<void> {
  return callVoid(`/v1/materials/${materialId}/progress`, {
    method: "POST",
    body: { milestone },
  });
}
